import { configureStore } from '@reduxjs/toolkit';
import formAdminReducer from './slices/formadmin';
import organizationReducer from './slices/organization';
import userReducer from './slices/user';

const store = configureStore({
  reducer: {
    formAdmin: formAdminReducer,
    organization: organizationReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppStore = typeof store;

export default store;
